import { render, staticRenderFns } from "./detalleComprasOrdenTrabajo.vue?vue&type=template&id=0db9df78"
import script from "./detalleComprasOrdenTrabajo.vue?vue&type=script&lang=js"
export * from "./detalleComprasOrdenTrabajo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports